module.exports = __webpack_public_path__ + "img/1F1FA-1F1FE.05eeb0fa.svg";